/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */

/**
 * Desktop sidebar auto-expand filter titles: remove hidden mobile toggle buttons from tab order.
 */
(function () {
  var DESKTOP_MQ = '(min-width: 1008px)';
  var SELECTOR =
    '#collection-filters-sidebar-form button.Collapsible__Button.hidden-lap-and-up[data-action="toggle-collapsible"],' +
    '#collection-filters-sidebar-form button.collapsible_button.hidden-lap-and-up[data-action="toggle-collapsible"]';

  function syncAutoExpandFilterTitles() {
    var isDesktop = window.matchMedia(DESKTOP_MQ).matches;
    document.querySelectorAll(SELECTOR).forEach(function (button) {
      if (isDesktop) {
        button.setAttribute('tabindex', '-1');
      } else if (button.getAttribute('tabindex') === '-1') {
        button.removeAttribute('tabindex');
      }
    });
  }

  function init() {
    syncAutoExpandFilterTitles();
    var mq = window.matchMedia(DESKTOP_MQ);
    if (typeof mq.addEventListener === 'function') {
      mq.addEventListener('change', syncAutoExpandFilterTitles);
    } else if (typeof mq.addListener === 'function') {
      mq.addListener(syncAutoExpandFilterTitles);
    }

    // Re-sync after collection filter AJAX updates replace sidebar markup
    document.addEventListener('collection:reloaded', syncAutoExpandFilterTitles);
    document.addEventListener('shopify:section:load', syncAutoExpandFilterTitles);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();

/**
 * VoiceOver / TalkBack focus rings: theme hides :focus outlines until body.is-tabbing
 * (set only on Tab). Assistive tech focus does not press Tab, so enable the same
 * class when focus moves inside collection filters.
 *
 * Also mark the visible option with .is-a11y-focused — Android TalkBack often
 * focuses clipped inputs without reliably matching :focus-within alone.
 */
(function () {
  var FILTER_FOCUS_ROOT =
    '.collection-filters-form, #collection-filter-drawer, #collection-filters-drawer-form, #collection-filters-sidebar-form';
  var OPTION_INPUT = '.ColorSwatch__Radio, .Linklist__Checkbox';

  function clearA11yFocused(scope) {
    var root = scope || document;
    root.querySelectorAll('.is-a11y-focused').forEach(function (el) {
      el.classList.remove('is-a11y-focused');
    });
  }

  function markFocusedOption(target) {
    if (!target || !target.closest) {
      return;
    }

    clearA11yFocused(target.closest(FILTER_FOCUS_ROOT) || document);

    if (!target.matches || !target.matches(OPTION_INPUT)) {
      return;
    }

    var option =
      target.closest('.HorizontalList__Item') ||
      target.closest('label.Link') ||
      target.closest('.Linklist__Item');

    if (option) {
      option.classList.add('is-a11y-focused');
    }
  }

  document.addEventListener(
    'focusin',
    function (event) {
      if (event.target && event.target.closest && event.target.closest(FILTER_FOCUS_ROOT)) {
        document.body.classList.add('is-tabbing');
        markFocusedOption(event.target);
      }
    },
    true
  );

  document.addEventListener(
    'focusout',
    function (event) {
      if (!event.target || !event.target.matches || !event.target.matches(OPTION_INPUT)) {
        return;
      }

      var option =
        event.target.closest('.HorizontalList__Item') ||
        event.target.closest('label.Link') ||
        event.target.closest('.Linklist__Item');

      if (option) {
        option.classList.remove('is-a11y-focused');
      }
    },
    true
  );
})();

/**
 * Mobile filter drawer accordion — expand/collapse filter groups (TalkBack / VoiceOver).
 * Matches .collapsible_button + .mobFilter_mainTitle_wrap + .showFillContent pattern.
 */
(function () {
  var MOBILE_MQ = '(max-width: 1007px)';
  var DRAWER_SELECTOR = '#collection-filter-drawer';

  function isMobileDrawerContext(button) {
    return button && button.closest(DRAWER_SELECTOR);
  }

  function shouldHandleToggle(button) {
    if (!isMobileDrawerContext(button)) {
      return false;
    }

    if (!window.matchMedia(MOBILE_MQ).matches) {
      return false;
    }

    if (
      button.closest('#collection-filters-sidebar-form') &&
      button.closest('.Collapsible--autoExpand') &&
      window.matchMedia('(min-width: 1008px)').matches
    ) {
      return false;
    }

    return true;
  }

  function getCollapsibleParts(button) {
    var wrap = button.closest('.mobFilter_mainTitle_wrap') || button.closest('.Collapsible');
    var inner = wrap ? wrap.querySelector('.Collapsible__Inner') : null;

    if (!inner) {
      var sibling = button.nextElementSibling;

      while (sibling && !sibling.classList.contains('Collapsible__Inner')) {
        sibling = sibling.nextElementSibling;
      }

      inner = sibling;
    }

    return { wrap: wrap, inner: inner };
  }

  function isVisibleFilterWrap(wrap) {
    if (!wrap) {
      return false;
    }

    return wrap.offsetParent !== null || (wrap.getClientRects && wrap.getClientRects().length > 0);
  }

  function clearInlineCollapsibleStyles(inner) {
    if (!inner) {
      return;
    }

    inner.style.removeProperty('height');
    inner.style.removeProperty('opacity');
    inner.style.removeProperty('visibility');
  }

  function resetMobileDrawerFilters() {
    if (!window.matchMedia(MOBILE_MQ).matches) {
      return;
    }

    var drawer = document.getElementById('collection-filter-drawer');

    if (!drawer) {
      return;
    }

    var buttons = drawer.querySelectorAll('[data-action="toggle-collapsible"]');
    var firstOpenButton = null;

    buttons.forEach(function (button) {
      var wrap = button.closest('.mobFilter_mainTitle_wrap') || button.closest('.Collapsible');

      if (!isVisibleFilterWrap(wrap)) {
        return;
      }

      if (wrap.classList.contains('showFillContent') || button.getAttribute('aria-expanded') === 'true') {
        if (!firstOpenButton) {
          firstOpenButton = button;
        }
      }
    });

    if (!firstOpenButton) {
      buttons.forEach(function (button) {
        var wrap = button.closest('.mobFilter_mainTitle_wrap') || button.closest('.Collapsible');

        if (!firstOpenButton && isVisibleFilterWrap(wrap)) {
          firstOpenButton = button;
        }
      });
    }

    buttons.forEach(function (button) {
      var parts = getCollapsibleParts(button);
      var wrap = parts.wrap;
      var inner = parts.inner;
      var open = button === firstOpenButton;

      button.setAttribute('aria-expanded', open ? 'true' : 'false');

      if (wrap) {
        wrap.classList.toggle('showFillContent', open);
      }

      if (inner) {
        clearInlineCollapsibleStyles(inner);

        if (open) {
          inner.removeAttribute('aria-hidden');
        } else {
          inner.setAttribute('aria-hidden', 'true');
        }
      }
    });
  }

  function setExpanded(button, expanded) {
    var parts = getCollapsibleParts(button);
    var wrap = parts.wrap;
    var inner = parts.inner;

    button.setAttribute('aria-expanded', expanded ? 'true' : 'false');

    if (wrap) {
      wrap.classList.toggle('showFillContent', expanded);
    }

    if (!inner || !inner.classList.contains('Collapsible__Inner')) {
      return;
    }

    if (!inner.id) {
      inner.id = button.id ? button.id + '-panel' : 'filter-panel-' + Date.now();
    }

    if (!button.getAttribute('aria-controls')) {
      button.setAttribute('aria-controls', inner.id);
    }

    if (expanded) {
      inner.removeAttribute('aria-hidden');
      inner.style.visibility = '';
      inner.style.opacity = '';
      inner.style.height = inner.scrollHeight + 'px';
    } else {
      inner.style.height = '0px';
      inner.style.opacity = '0';
      inner.style.visibility = 'hidden';
      inner.setAttribute('aria-hidden', 'true');
    }
  }

  function isExpanded(button) {
    return button.getAttribute('aria-expanded') === 'true';
  }

  function toggleFilterCollapsible(button) {
    if (!shouldHandleToggle(button)) {
      return;
    }

    var drawer = button.closest(DRAWER_SELECTOR);
    var expanded = isExpanded(button);

    if (expanded) {
      setExpanded(button, false);
      return;
    }

    drawer.querySelectorAll('[data-action="toggle-collapsible"]').forEach(function (other) {
      setExpanded(other, other === button);
    });
  }

  function syncDrawerCollapsibles() {
    resetMobileDrawerFilters();
  }

  function onToggle(event) {
    var button = event.target.closest('[data-action="toggle-collapsible"]');

    if (!button || !shouldHandleToggle(button)) {
      return;
    }

    toggleFilterCollapsible(button);
    document.dispatchEvent(new CustomEvent('collection:filter-labels:sync'));
  }

  function initFilterDrawerCollapsibles() {
    syncDrawerCollapsibles();
    document.dispatchEvent(new CustomEvent('collection:filter-labels:sync'));
  }

  document.addEventListener('click', onToggle, true);

  document.addEventListener('collection:reloaded', initFilterDrawerCollapsibles);
  document.addEventListener('shopify:section:load', initFilterDrawerCollapsibles);

  document.addEventListener('click', function (event) {
    var opener = event.target.closest('[data-action="open-drawer"][data-drawer-id="collection-filter-drawer"]');

    if (opener) {
      window.setTimeout(initFilterDrawerCollapsibles, 0);
      window.setTimeout(initFilterDrawerCollapsibles, 400);
    }
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initFilterDrawerCollapsibles);
  } else {
    initFilterDrawerCollapsibles();
  }
})();

/**
 * Filter groups as a list of titles (Lens Color, Size, …).
 * aria-label on each title is the filter name only.
 */
(function () {
  var FILTER_FORM_SELECTOR = '#collection-filters-sidebar-form, #collection-filters-drawer-form';
  var DESKTOP_MQ = '(min-width: 1008px)';

  function isVisibleFilterGroup(el) {
    if (!el) {
      return false;
    }

    return el.offsetParent !== null || (el.getClientRects && el.getClientRects().length > 0);
  }

  function getTopLevelFilterGroups(form) {
    var groups = form.querySelectorAll('.Collapsible[data-filter-index]');

    return Array.prototype.filter.call(groups, isVisibleFilterGroup);
  }

  function getFilterTitleText(collapsible) {
    var mobileBtn = collapsible.querySelector('button[data-action="toggle-collapsible"]');
    var desktopTitle = collapsible.querySelector('.Collapsible__FilterTitle');
    var booleanLabel = collapsible.querySelector('.BooleanFilter label.Heading');

    if (mobileBtn) {
      var clone = mobileBtn.cloneNode(true);
      var plus = clone.querySelector('.Collapsible__Plus');

      if (plus) {
        plus.remove();
      }

      return clone.textContent.replace(/\s+/g, ' ').trim();
    }

    if (desktopTitle) {
      return desktopTitle.textContent.replace(/\s+/g, ' ').trim();
    }

    if (booleanLabel) {
      return booleanLabel.textContent.replace(/\s+/g, ' ').trim();
    }

    return '';
  }

  function cleanupMobileGroupListDesc(form) {
    form.querySelectorAll('.CollectionFilterGroup__ListDesc').forEach(function (el) {
      el.remove();
    });

    form.querySelectorAll('.Collapsible__Content[role="group"]').forEach(function (group) {
      group.removeAttribute('aria-describedby');
    });

    form.querySelectorAll('ul.Linklist, ul.ColorSwatchList, ul.HorizontalList').forEach(function (ul) {
      if (!ul.getAttribute('role')) {
        ul.setAttribute('role', 'list');
      }
    });
  }

  function syncFilterGroupListLabels(root) {
    var scope = root || document;
    var isDesktop = window.matchMedia(DESKTOP_MQ).matches;

    scope.querySelectorAll(FILTER_FORM_SELECTOR).forEach(function (form) {
      cleanupMobileGroupListDesc(form);

      form.setAttribute('role', 'list');

      var groups = getTopLevelFilterGroups(form);

      if (groups.length === 0) {
        return;
      }

      groups.forEach(function (collapsible) {
        collapsible.setAttribute('role', 'listitem');

        var title = getFilterTitleText(collapsible);

        if (!title) {
          return;
        }

        var mobileBtn = collapsible.querySelector('button[data-action="toggle-collapsible"]');
        var desktopTitle = collapsible.querySelector('.Collapsible__FilterTitle');
        var booleanLabel = collapsible.querySelector('.BooleanFilter label.Heading');
        var group = collapsible.querySelector('.Collapsible__Content[role="group"]');

        if (isDesktop) {
          if (desktopTitle) {
            desktopTitle.setAttribute('aria-label', title);
          } else if (booleanLabel) {
            booleanLabel.setAttribute('aria-label', title);
          }

          if (mobileBtn) {
            mobileBtn.removeAttribute('aria-label');
          }

          if (group && desktopTitle && desktopTitle.id) {
            group.setAttribute('aria-labelledby', desktopTitle.id);
          } else if (group && booleanLabel && booleanLabel.id) {
            group.setAttribute('aria-labelledby', booleanLabel.id);
          }
        } else {
          if (mobileBtn) {
            mobileBtn.setAttribute('aria-label', title);
          } else if (booleanLabel) {
            booleanLabel.setAttribute('aria-label', title);
          }

          if (desktopTitle) {
            desktopTitle.removeAttribute('aria-label');
          }

          if (group && mobileBtn && mobileBtn.id) {
            group.setAttribute('aria-labelledby', mobileBtn.id);
          } else if (group && booleanLabel && booleanLabel.id) {
            group.setAttribute('aria-labelledby', booleanLabel.id);
          }
        }
      });
    });
  }

  function initFilterGroupListLabels() {
    syncFilterGroupListLabels();
  }

  document.addEventListener('collection:reloaded', initFilterGroupListLabels);
  document.addEventListener('shopify:section:load', initFilterGroupListLabels);
  document.addEventListener('collection:filter-labels:sync', initFilterGroupListLabels);

  document.addEventListener('click', function (event) {
    if (event.target.closest('[data-action="open-drawer"][data-drawer-id="collection-filter-drawer"]')) {
      window.setTimeout(initFilterGroupListLabels, 0);
      window.setTimeout(initFilterGroupListLabels, 400);
    }
  });

  var desktopMq = window.matchMedia(DESKTOP_MQ);

  if (typeof desktopMq.addEventListener === 'function') {
    desktopMq.addEventListener('change', initFilterGroupListLabels);
  } else if (typeof desktopMq.addListener === 'function') {
    desktopMq.addListener(initFilterGroupListLabels);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initFilterGroupListLabels);
  } else {
    initFilterGroupListLabels();
  }
})();

/**
 * Engraving tooltip (WCAG 1.4.13): dismissible with Esc, hoverable, persistent.
 */
(function () {
  function initEngravingTooltip(root) {
    if (!root || root.getAttribute('data-tooltip-ready') === 'true') {
      return;
    }

    var trigger = root.querySelector('.engraving-tooltip__trigger');
    var tip = root.querySelector('.tooltiptext');

    if (!trigger || !tip) {
      return;
    }

    root.setAttribute('data-tooltip-ready', 'true');

    var dismissed = false;

    function openTooltip() {
      if (dismissed) {
        return;
      }

      root.classList.add('is-open');
      tip.setAttribute('aria-hidden', 'false');
      trigger.setAttribute('aria-expanded', 'true');
    }

    function closeTooltip() {
      root.classList.remove('is-open');
      tip.setAttribute('aria-hidden', 'true');
      trigger.setAttribute('aria-expanded', 'false');
    }

    trigger.addEventListener('focus', function () {
      dismissed = false;
      openTooltip();
    });

    trigger.addEventListener('blur', function () {
      window.setTimeout(function () {
        if (!root.contains(document.activeElement) && !root.matches(':hover')) {
          dismissed = false;
          closeTooltip();
        }
      }, 0);
    });

    root.addEventListener('mouseenter', function () {
      dismissed = false;
      openTooltip();
    });

    root.addEventListener('mouseleave', function () {
      if (document.activeElement === trigger) {
        // Keep open while keyboard focus remains on the trigger
        return;
      }

      dismissed = false;
      closeTooltip();
    });

    trigger.addEventListener('keydown', function (event) {
      if (event.key !== 'Escape' && event.key !== 'Esc') {
        return;
      }

      if (!root.classList.contains('is-open')) {
        return;
      }

      event.preventDefault();
      event.stopPropagation();
      dismissed = true;
      closeTooltip();
    });
  }

  function initAllEngravingTooltips() {
    document.querySelectorAll('.engraving-tooltip').forEach(initEngravingTooltip);
  }

  document.addEventListener('shopify:section:load', initAllEngravingTooltips);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAllEngravingTooltips);
  } else {
    initAllEngravingTooltips();
  }

  // Quick view / dynamic product forms may inject the snippet later
  var observer = new MutationObserver(function (mutations) {
    for (var i = 0; i < mutations.length; i++) {
      var nodes = mutations[i].addedNodes;
      for (var j = 0; j < nodes.length; j++) {
        var node = nodes[j];
        if (node.nodeType !== 1) {
          continue;
        }
        if (node.matches && node.matches('.engraving-tooltip')) {
          initEngravingTooltip(node);
        } else if (node.querySelectorAll) {
          node.querySelectorAll('.engraving-tooltip').forEach(initEngravingTooltip);
        }
      }
    }
  });

  observer.observe(document.documentElement, {
    childList: true,
    subtree: true
  });
})();

/**
 * Add Prescription (LensAdvizor) — button semantics + WCAG 2.5.3 Label in Name.
 * Visible text must provide (or be included in) the accessible name.
 * Do not change visual styles.
 */
(function () {
  var SELECTOR = 'lensadvizor-quick-buy.la-select-lenses-btn, lensadvizor-btn.la-select-lenses-btn, lensadvizor-btn#la-select-lenses-btn';

  function visibleLabel(el) {
    return (el.textContent || '').replace(/\s+/g, ' ').trim();
  }

  function syncAccessibleName(el) {
    var label = visibleLabel(el);
    if (!label) {
      return;
    }

    var ariaLabel = el.getAttribute('aria-label');
    if (!ariaLabel) {
      return;
    }

    // 2.5.3: accessible name must contain the visible label (case-insensitive)
    if (ariaLabel.toLowerCase().indexOf(label.toLowerCase()) === -1) {
      el.removeAttribute('aria-label');
    }
  }

  function enhanceLensAdvizorButton(el) {
    if (!el || el.nodeType !== 1) {
      return;
    }

    var tag = el.tagName;
    if (tag !== 'LENSADVIZOR-QUICK-BUY' && tag !== 'LENSADVIZOR-BTN') {
      return;
    }

    if (el.getAttribute('role') !== 'button') {
      el.setAttribute('role', 'button');
    }
    if (el.getAttribute('tabindex') !== '0') {
      el.setAttribute('tabindex', '0');
    }
    if (el.getAttribute('aria-haspopup') !== 'dialog') {
      el.setAttribute('aria-haspopup', 'dialog');
    }

    syncAccessibleName(el);

    if (el.dataset.a11yButtonBound === 'true') {
      return;
    }
    el.dataset.a11yButtonBound = 'true';

    el.addEventListener('keydown', function (event) {
      if (event.key !== 'Enter' && event.key !== ' ' && event.key !== 'Spacebar') {
        return;
      }
      event.preventDefault();
      el.click();
    });
  }

  function enhanceAll() {
    document.querySelectorAll(SELECTOR).forEach(enhanceLensAdvizorButton);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', enhanceAll);
  } else {
    enhanceAll();
  }

  // App may rewrite text / aria-label after load — keep Label in Name in sync
  var observer = new MutationObserver(function (mutations) {
    for (var i = 0; i < mutations.length; i++) {
      var mutation = mutations[i];
      if (mutation.type === 'childList') {
        for (var j = 0; j < mutation.addedNodes.length; j++) {
          var node = mutation.addedNodes[j];
          if (node.nodeType !== 1) {
            continue;
          }
          if (node.matches && node.matches(SELECTOR)) {
            enhanceLensAdvizorButton(node);
          } else if (node.querySelectorAll) {
            node.querySelectorAll(SELECTOR).forEach(enhanceLensAdvizorButton);
          }
        }
      } else if (mutation.type === 'attributes' || mutation.type === 'characterData') {
        var target = mutation.target;
        if (target.nodeType === 3) {
          target = target.parentElement;
        }
        if (target && target.closest) {
          var btn = target.closest(SELECTOR);
          if (btn) {
            enhanceLensAdvizorButton(btn);
          }
        }
      }
    }
  });

  observer.observe(document.documentElement, {
    childList: true,
    subtree: true,
    characterData: true,
    attributes: true,
    attributeFilter: ['style', 'class', 'tabindex', 'role', 'aria-label']
  });
})();
